export function generateShape() {
  const shapes = ["circle", "square", "triangle"];
  return shapes[Math.floor(Math.random() * shapes.length)];
}


export function analyzeResult(real, userCounts) {
  const realCounts = {
    rectangle: 0,
    circle: 0,
    triangle: 0,
  };

  real.forEach((item) => {
    realCounts[item.type]++;
  });

  let correct = 0;
  let total = 3;

  if (realCounts.rectangle === Number(userCounts.rectangle)) correct++;
  if (realCounts.circle === Number(userCounts.circle)) correct++;
  if (realCounts.triangle === Number(userCounts.triangle)) correct++;

  return {
    correct,
    total,
    accuracy: Math.round((correct / total) * 100),
    realCounts,   // ⚠ VERY IMPORTANT
  };
}
